import { Session } from '@benzinga/session';
import { ContentManager, WordpressPage, VertialQuery } from '@benzinga/content-manager';

export const getMoneyPage = async (session: Session, page_id: number): Promise<WordpressPage | null> => {
  const contentManager = session.getManager(ContentManager);
  const pageRes = await contentManager.getPage(page_id);
  return pageRes?.ok ?? null;
};

export const getVertical = async (session: Session, params: VertialQuery) => {
  const contentManager = session.getManager(ContentManager);
  const pageRes = await contentManager.getVertical(params);
  return pageRes?.ok ?? null;
};
